import { render } from "./course-table.vue?vue&type=template&id=650b4097"
import script from "./course-table.vue?vue&type=script&lang=js"
export * from "./course-table.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aderito/Sites/clients/wordpress/UMBC-shady-grove/web/wp-content/plugins/mg-umbc-course-retriever/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__